export const Error = ({ title, subtitle }) => {
  return (
    <div className="flex flex-col justify-center items-center h-48 p-10 bg-[#f9f9f9]">
      <p className="text-2xl font-bold mb-8">{title}</p>
      <span className="text-sm block">{subtitle}</span>
    </div>
  );
};
